import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";

const COLOR_CSS = "black";

const css = {
  wrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }
};

LoadingView.propTypes = {
  sizePX: PropTypes.number
};

LoadingView.defaultProps = {
  sizePX: 40
};

function LoadingView(props) {
  const { sizePX } = props;

  return (
    <div style={css.wrapper}>
      <CircularProgress
        style={{ color: COLOR_CSS, width: sizePX, height: sizePX }}
      />
    </div>
  );
}

export default LoadingView;
